import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import React from 'react';
import { FeatureToggleReducer, getUserFeatures } from './feature-toggle.state';
import { FeatureToggleData, FeatureToggleProps } from './feature-toggle.utility-types';

export interface WithFeatureToggleProps{
    featureToggle: FeatureToggleData
}

export const withFeatureToggle = connect(
    (state: FeatureToggleReducer) => ({
        featureToggle: state.featureToggle,
    }),
    dispatch => bindActionCreators({
        getUserFeatures,
    }, dispatch),
);

export interface WithToggleAuthorization {
    userIsAuthorizedToUseFeature: (string) => string
}

export const withToggleAuthorization = (Component: typeof React.Component) => {
    const WithToggleAuthorization = ({ featureToggle, ...extra }: FeatureToggleProps) => {
        const { features: userFeatures } = featureToggle.data;
        const userIsAuthorizedToUseFeature = feature => userFeatures[feature];

        return (
            <Component
                userIsAuthorizedToUseFeature={userIsAuthorizedToUseFeature}
                {...extra}
            />
        );
    };

    return compose(withFeatureToggle)(WithToggleAuthorization);
};
